import React from 'react'
import styled, { Keyframes, css, keyframes } from 'styled-components'

function blinkingEffect(): Keyframes {
  return keyframes`
    50% {
      opacity: 0;
    }
  `
}

export interface BlinkingComponentProps {
  blinking?: boolean
  children?: React.ReactNode
}

const StyledDiv = styled.div<{ $blinking: boolean; children?: React.ReactNode }>`
  display: flex;
  animation: ${({ $blinking }) =>
    $blinking
      ? css`
          ${blinkingEffect()} 1s linear infinite
        `
      : 'none'};
`

export default function BlinkingComponent({ blinking = true, children }: BlinkingComponentProps) {
  return <StyledDiv $blinking={blinking}>{children}</StyledDiv>
}
